import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const useLogin = () => {
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateCode = (value) => /^\d+$/.test(String(value).trim()); // Must be numeric

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateCode(code)) {
      const message = 'Code must be a numeric value.';
      setError(message);
      toast.error(message);
      return;
    }

    if (!password) {
      const message = 'Password is required.';
      setError(message);
      toast.error(message);
      return;
    }

    try {
      setLoading(true);

    const response = await axiosApi.post('/auth/login', {
      code: String(code).trim(),
        password,
      });

      const { token, userId, role } = response.data;

      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('userId', userId);
        localStorage.setItem('role', role);

        toast.success('Login successful! Redirecting...');

        setTimeout(() => {
          switch (role) {
            case 'admin':
              navigate('/DashboardAdmin');
              break;
            case 'guest':
              navigate('/DashboardGuest');
              break;
            case 'noso':
              navigate('/DashboardNoso');
              break;
            case 'bohol':
              navigate('/DashboardBohol');
              break;
            case 'siquijor':
              navigate('/DashboardSiquijor');
              break;
            case 'cebu':
              navigate('/DashboardCebu');
              break;
            case 'nis':
              navigate('/DashboardNis');
              break;
            default:
              setError('Unknown role, access denied.');
              toast.error('Unknown role, access denied.');
          }
        }, 1000);
      } else {
        throw new Error('Invalid login response');
      }
    } catch (err) {
      const message =
        err.response?.data?.message || 'Login failed. Please try again.';
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return {
    code,
    setCode,
    password,
    setPassword,
    error,
    setError,
    loading,
    handleLogin,
  };
};

export default useLogin;
